export default __webpack_public_path__ + "static/media/frontdesk-reservations.8d522fa9.webp";